import { NavigationLinkProps } from "../../providers/Router";
import SettingsPage from "./pages/SettingsPage";

const SettingsRouter: NavigationLinkProps[] = [
  {
    id: "932f56af-045a-4d79-a765-5a002b72ea22",
    title: "Settings",
    description: "",
    path: "/settings",
    auth: true,
    sidebar: false,
    component: SettingsPage,
    requiredFeature: "ANY",
    requiredPermissions: ["ANY"],
    mobileAvailable: true,
  },
];

export default SettingsRouter;
